module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dbff6359a3f338d5581c626ee50acf60.svg";